import { useEffect, useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackPixelPageView } from '../../utils/analytics';

/*
  SPA 라우팅 추적

  - Nav 의 주요 메뉴(/teacher, /pay, /service)는 <a href> 라서 페이지가 새로 로드되지만
    로고와 Footer 링크(/, /terms, /privacy, /email-policy)는 <Link> 라서 새로 로드되지 않는다.
    새로 로드되지 않는 이동은 GA·픽셀이 스스로 잡지 못하므로 여기서 직접 보낸다.
  - 최초 진입 1회는 Firebase Analytics 자동 page_view 와 index.html 의 fbq PageView 가
    이미 보내므로 여기서 보내지 않는다. (중복 집계 방지)
  - 모든 페이지의 <title> 이 같으면 GA4 '페이지 제목' 보고서에서 한 줄로 합쳐져
    하위 페이지 조회수가 보이지 않는다. 경로별 제목을 여기서 지정한다.
*/

const PAGE_TITLES = {
  '/': '두고팡 - 즐거운 바둑 플랫폼',
  '/teacher': '두고팡 프리미엄 - 두고팡',
  '/service': '고객센터 - 두고팡',
  '/pay': '이용금액 - 두고팡',
  '/questionform': '문의하기 - 두고팡',
  '/terms': '이용약관 - 두고팡',
  '/privacy': '개인정보처리방침 - 두고팡',
  '/email-policy': '이메일무단수집거부 - 두고팡'
};

const DEFAULT_TITLE = '두고팡 - 즐거운 바둑 플랫폼';

const resolveTitle = (pathname) => {
  const key = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return PAGE_TITLES[key] || DEFAULT_TITLE;
};

const RouteTracker = () => {
  const { pathname } = useLocation();
  // 최초 진입 경로를 넣어두면 첫 렌더는 '변경 없음'으로 처리되어 중복 전송이 일어나지 않는다.
  const lastPathRef = useRef(pathname);

  // 제목은 GA 가 page_view 를 만들기 전에 정해져 있어야 하므로 렌더 직후 동기로 반영한다.
  useLayoutEffect(() => {
    document.title = resolveTitle(pathname);
  }, [pathname]);

  useEffect(() => {
    if (lastPathRef.current === pathname) {
      return;
    }
    lastPathRef.current = pathname;

    trackPageView(document.title);
    trackPixelPageView();
  }, [pathname]);

  return null;
};

export default RouteTracker;
